// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/light-signals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/light-signals/light-gun-vehicle-personnel-signals.js';
import g1 from '../lessons/air-law/light-signals/light-signals.js';

mount([g0, g1]);
